export default __webpack_public_path__ + "static/media/sunsetMask.c68a15d8.svg";